import { Controller } from "@hotwired/stimulus"

/**
 * MCP Log Entry Controller — toggles the JSON detail panel
 * on a single McpRequestLogEntryComponent row.
 */
export default class extends Controller {
  static targets = ["detail"]

  toggle() {
    this.detailTarget.classList.toggle("hidden")
  }
}
